/**
 * For maintainability we should separate controllers into their own modules
 */
angular.module('acme.view.application.themes.donation.modals.deactivate.controllers', [])

.controller('ThemesDonationModalsDeactivateController', [
  '$scope', '$uibModalInstance',
  'themeItem',
  function(
    $scope, $uibModalInstance,
    themeItem
  ) {
    $scope.themesDonationModalsDeactivate = {

      model: "Your spankin new application.themes.donation.modals.deactivate view!",

      init: function() {
        this.setModel();
      },

      setModel: function() {
        this.model = Object.assign({},themeItem);
      },

      cancel: function () {
        $uibModalInstance.dismiss('cancel');
      },

      done: function() {
        this.model.archived = true;
        $uibModalInstance.close(this.model);
      }

    };

    $scope.themesDonationModalsDeactivate.init();

}]);
